import { createGlobalStyle } from 'styled-components';

import HedvigLettersSansRegular from './HedvigLettersSans-Regular.ttf';

export default createGlobalStyle`
  @font-face {
    font-family: 'HedvigLettersSans';
    src: local('Inter'), url(${HedvigLettersSansRegular}) format('truetype');
    font-weight: 400;
    font-style: normal;
  }
}`;
